import { memo } from 'react'
import { Skeleton } from '../../../shared/ui/Skeleton'

export const GroupRowSkeleton = memo(function GroupRowSkeleton() {
  return (
    <div
      style={{
        padding: 20,
        borderRadius: 12,
        border: '1px solid var(--panel-border)',
        background: 'var(--panel)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 16,
      }}
    >
      <div style={{ flex: 1 }}>
        <Skeleton className="mb-2 h-6 w-48" />
        <Skeleton className="mb-3 h-4 w-64" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-32" />
        </div>
        <Skeleton className="mt-3 h-3 w-24 opacity-70" />
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <Skeleton className="h-9 w-16 rounded-md" />
        <Skeleton className="h-9 w-16 rounded-md" />
      </div>
    </div>
  )
})
